import React from 'react'
import PropTypes from 'prop-types'


export const TableDataRow = ({ row, columns, onClick }) => {
  let rowData = row.map((data, index) => {
    if (index === 0) {
      return (
        <th scope='row' data-label={columns ? columns[index] : ''} key={'table_row_'+index}>
          <div className='slds-cell-wrap' title={data}>
            {data}
          </div>
        </th>
      )
    } else {
      return (
        <td data-label={columns ? columns[index] : ''} key={'table_row_'+index}>
          <div className='slds-cell-wrap' title={data}>
            {data}
          </div>
        </td>
      )
    }
  })

  return (
    <tr onClick={onClick}>
      {rowData}
    </tr>
  )
}

TableDataRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])),
  row: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]))
}



// WEBPACK FOOTER //
// ./src/components/table/TableDataRow.js